<ng-container>
  <cx-store-finder-search></cx-store-finder-search>
</ng-container>
